import { render, staticRenderFns } from "./SplashWindow.vue?vue&type=template&id=4a743458"
import script from "./SplashWindow.vue?vue&type=script&lang=js"
export * from "./SplashWindow.vue?vue&type=script&lang=js"
import style0 from "./SplashWindow.vue?vue&type=style&index=0&id=4a743458&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports